import React, { useState } from 'react'
import { playerCardStyles as styles } from "./ExpandedLeaderboard.tailwind";
import { getTrophyIcon } from '../../../MyAccount/Sections/LiveGameSection/Sections/GameLeaderboard/leaderboard.data';
import { getFirstCharUpperCase, getRandomColor } from '../../../../lib/constants/globalConstant';
import { Avatar } from '@mui/material';

const PlayerCard = ({ innerImageWrapperClassName, details, skeleton }) => {
  const [failedImageLoad, setFailedImageLoad] = useState(false);

  return (
    <div className={`${styles.playerCard} ${!details ? skeleton ? styles.skeleton : 'invisible' : ''}`}>
      {/* Trophy/ Rank */}
      {details?.rank <= 3 ? (
        <img src={getTrophyIcon(details?.rank)} alt="Trophy" className={styles.trophyIcon} />
      ) : (
        <span className={styles.rank}>{details?.rank}</span>
      )}

      <div className={`${styles.playerImageWrpr} ${innerImageWrapperClassName}`}>
        {/* Player Image */}
        {!details ? null : ((details?.userProfileImageUrl && !failedImageLoad)) ? (
            <img src={details?.userProfileImageUrl} alt="pic" className={styles.playerImage} onError={() => setFailedImageLoad(true)} />
        ) : (
            <Avatar
                sx={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "0px",
                    bgcolor: getRandomColor(getFirstCharUpperCase(details?.userNickName)),
                }}
            >
                {getFirstCharUpperCase(details?.userNickName)}
            </Avatar>
        )}

        {/* Player Name */}
        <div className={styles.player_name_label}>
          {details?.userNickName}
        </div>
      </div>

      {/* Points */}
      {!details ? null : (
        <p className={styles.points}>
            {details?.tokenPoints} <span className='text-white'>Points</span>
        </p>
    )}
    </div>
  )
}

export default PlayerCard
